/**
 * Whether the Data tab renders the revamped module (`data-revamp-new`) or the
 * original `Import` module. Same shape as `dimensionsRevampFlag`: the
 * LaunchDarkly flag when defined, otherwise on.
 *
 * Keyed `dataRevampNew` rather than `dataRevamp` on purpose: LaunchDarkly wins
 * whenever it defines a flag, so a pre-existing `dataRevamp` flag set to false
 * in the project would silently keep the original module on screen.
 */
export const isDataRevampEnabled = (flags?: { dataRevampNew?: boolean }): boolean =>
  flags?.dataRevampNew ?? true;

export default isDataRevampEnabled;
